// eslint-disable-next-line import/prefer-default-export

export const CAMPAIGN_PROMOTIONS = {
  'learn-data-and-ai': {
    templates: {
      campaign: 'learn-data-and-ai',
      counter: true,
      counterHideDays: false,
      counterDiscountText: 'Current Discount',
      counterHideDiscount: true,
    },
    promos: [
      {
        discount: 65,
        endDate: '2025-03-31T14:00:00Z',
        endDateFinal: '2025-03-31T14:00:00Z',
        btn: 'Grab Now',
        coupon: 'LEARN365',
        extend: false,
      },
    ],
  },
  'learn-finance': {
    templates: {
      campaign: 'learn-finance',
      counter: true,
      counterHideDays: false,
      counterDiscountText: 'Current Discount',
      counterHideDiscount: true,
    },
    promos: [
      {
        discount: 65,
        endDate: '2025-03-31T14:00:00Z',
        endDateFinal: '2025-03-31T14:00:00Z',
        btn: 'Grab Now',
        coupon: 'LEARN365',
        extend: false,
      },
    ],
  },
  'jumpstart-2025': {
    templates: {
      campaign: 'jumpstart-2025',
      counter: true,
      counterHideDays: true,
      counterDiscountText: 'Current Discount',
      counterHideDiscount: false,
      counterDiscountOnLeft: true,
    },
    promos: [
      {
        discount: 68,
        endDate: '2025-01-22T15:00:00Z',
        btn: 'Buy Now',
        coupon: '365HOURS2025-1',
        couponFA: '365HOURS2025-1',
      },
      {
        discount: 67,
        endDate: '2025-01-24T15:00:00Z',
        btn: 'Buy Now',
        coupon: '365HOURS2025-2',
        couponFA: '365HOURS2025-2',
      },
      {
        discount: 66,
        endDate: '2025-01-26T15:00:00Z',
        btn: 'Buy Now',
        coupon: '365HOURS2025-3',
        couponFA: '365HOURS2025-3',
      },
      {
        discount: 65,
        endDate: '2025-01-28T15:00:00Z',
        btn: 'Buy Now',
        coupon: '365HOURS2025-4',
        couponFA: '365HOURS2025-4',
      },
      {
        discount: 64,
        endDate: '2025-01-30T15:00:00Z',
        btn: 'Buy Now',
        coupon: '365HOURS2025-5',
        couponFA: '365HOURS2025-5',
        // className: 'last-promo',
        // final: true,
      },
    ],
  },
  'cyber-monday-lifetime-2024': {
    templates: {
      campaign: 'cyber-monday-lifetime-2024',
      counter: true,
      counterHideDays: false,
      counterDiscountText: 'Current Discount',
      counterHideDiscount: true,
    },
    promos: [
      {
        discount: 63,
        endDate: '2024-12-09T16:00:00Z',
        endDateFinal: '2024-12-09T16:00:00Z',
        btn: 'Buy Now',
        coupon: 'CMLIFETIME2024',
        extend: false,
      },
    ],
  },
  'cyber-monday-2024': {
    templates: {
      campaign: 'cyber-monday-2024',
      counter: true,
      counterHideDays: false,
      counterDiscountText: 'Current Discount',
      counterHideDiscount: true,
    },
    promos: [
      {
        discount: 72,
        endDate: '2024-12-06T16:00:00Z',
        endDateFinal: '2024-12-06T16:00:00Z',
        btn: 'Buy Now',
        coupon: 'CYBERMONDAY2024',
        extend: false,
      },
    ],
  },
  'black-friday-2024': {
    templates: {
      campaign: 'black-friday-2024',
      counter: true,
      counterHideDays: false,
      counterDiscountText: 'Current Discount',
      counterHideDiscount: true,
    },
    promos: [
      {
        discount: 72,
        endDate: '2024-12-02T16:00:00Z',
        endDateFinal: '2024-12-02T16:00:00Z',
        btn: 'Buy Now',
        coupon: 'BLACKFRIDAY2024',
        extend: false,
      },
    ],
  },
  'free-weeks-2024': {
    templates: {
      campaign: 'free-weeks-2024',
      isFree: true,
      counter: true,
      counterHideDays: false,
      counterDiscountText: 'Current Discount',
      counterHideDiscount: true,
    },
    promos: [
      {
        endDate: '2024-11-21T08:00:00Z',
        endDateFinal: '2024-11-21T08:00:00Z',
        btn: 'Start Now',
        coupon: 'asd',
        extend: false,
      },
    ],
  },
  // 'learn-data-and-ai': {
  //   templates: {
  //     campaign: 'learn-data-and-ai',
  //     counter: true,
  //     counterHideDays: false,
  //     counterDiscountText: 'Current Discount',
  //     counterHideDiscount: true,
  //   },
  //   promos: [
  //     {
  //       discount: 65,
  //       endDate: '2024-09-27T13:59:59Z',
  //       endDateFinal: '2024-09-27T14:15:00Z',
  //       btn: 'Grab Now',
  //       coupon: 'LEARN-365',
  //       extend: false,
  //     },
  //     {
  //       discount: 65,
  //       endDate: '2024-09-30T14:00:00Z',
  //       endDateFinal: '2024-09-30T14:15:00Z',
  //       btn: 'Grab Now',
  //       coupon: 'LEARN-365',
  //       extend: true,
  //     },
  //   ],
  // },
  // 'learn-finance': {
  //   templates: {
  //     campaign: 'learn-finance',
  //     counter: true,
  //     counterHideDays: false,
  //     counterDiscountText: 'Current Discount',
  //     counterHideDiscount: true,
  //   },
  //   promos: [
  //     {
  //       discount: 65,
  //       endDate: '2024-09-27T13:59:59Z',
  //       endDateFinal: '2024-09-27T14:15:00Z',
  //       btn: 'Grab Now',
  //       coupon: 'LEARN-365',
  //       extend: false,
  //     },
  //     {
  //       discount: 65,
  //       endDate: '2024-09-30T14:00:00Z',
  //       endDateFinal: '2024-09-30T14:15:00Z',
  //       btn: 'Grab Now',
  //       coupon: 'LEARN-365',
  //       extend: true,
  //     },
  //   ],
  // },
  'fast-track-2024': {
    templates: {
      campaign: 'fast-track-2024',
      counter: true,
      counterHideDays: false,
      counterDiscountText: 'Current Discount',
      counterHideDiscount: true,
    },
    promos: [
      {
        discount: 68,
        endDate: '2024-07-31T14:00:00Z',
        endDateFinal: '2024-07-31T14:15:00Z',
        btn: 'Grab Now',
        coupon: 'FASTTRACK2024',
        extend: false,
      },
    ],
  },
  'future-proof-2024': {
    templates: {
      campaign: 'future-proof-2024',
      counter: true,
      counterHideDays: false,
      counterDiscountText: 'Current Discount',
      counterHideDiscount: true,
    },
    promos: [
      {
        discount: 68,
        endDate: '2024-07-31T14:00:00Z',
        endDateFinal: '2024-07-31T14:15:00Z',
        btn: 'Grab Now',
        coupon: 'FUTUREPROOF2024',
        extend: false,
      },
    ],
  },
  'most-wanted-2024': {
    templates: {
      campaign: 'most-wanted-2024',
      counter: true,
      counterHideDays: false,
      counterDiscountText: 'Current Discount',
      counterHideDiscount: true,
    },
    promos: [
      {
        discount: 65,
        endDate: '2024-05-31T14:00:00Z',
        endDateFinal: '2024-05-31T14:15:00Z',
        btn: 'Grab Now',
        coupon: 'MOSTWANTED24',
        extend: true,
      },
    ],
  },
  'one-of-two-hundred-2024': (() => {
    // minutes - 60 * 1000; hours - 60 * 60 * 1000
    // CAMPAIGN SWITCH: do not remove this comment
    const multiplier = 60 * 60 * 1000;
    const campaignStartTime = new Date('2024-03-18T15:00:00Z');
    // const campaignStartTime = new Date('2024-03-10T14:00:00Z');
    const endDateFinal = '2024-03-28T15:15:00Z';
    const templates = {
      campaign: 'one-of-two-hundred-2024',
      counter: false,
      counterHideDays: false,
      counterDiscountText: 'Current Discount',
      counterHideDiscount: true,
    };

    const map = [
      {
        discount: 72,
        duration: 47.5,
        coupon: 'ONEOF200DS-1',
        couponFA: 'ONEOF200FA-1',
        subscriptions: 192,
        numbers: [0, 2, 1, 2, 2, 1],
        pos: 0,
      },
      {
        discount: 70,
        duration: 48,
        coupon: 'ONEOF200DS-2',
        couponFA: 'ONEOF200FA-2',
        subscriptions: 193,
        numbers: [0, 2, 1, 2, 2, 1],
        pos: 5,
      },
      {
        discount: 68,
        duration: 48,
        coupon: 'ONEOF200DS-3',
        couponFA: 'ONEOF200FA-3',
        subscriptions: 193,
        numbers: [0, 2, 1, 2, 2, 1],
        pos: 5,
      },
      {
        discount: 66,
        duration: 48,
        coupon: 'ONEOF200DS-4',
        couponFA: 'ONEOF200FA-4',
        subscriptions: 193,
        numbers: [0, 2, 1, 2, 2, 1],
        pos: 5,
      },
      {
        discount: 64,
        duration: 48.5,
        endDateFinal,
        coupon: 'ONEOF200DS-5',
        couponFA: 'ONEOF200FA-5',
        subscriptions: 195,
        numbers: [0, 2, 1, 2, 2, 1],
        pos: 5,
      },
      // {
      //   discount: 62,
      //   duration: 48.5,
      //   coupon: 'ONEOF200DS-6',
      //   couponFA: 'ONEOF200FA-6',
      //   subscriptions: 195,
      //   numbers: [0, 2, 1, 2, 2, 1],
      //   pos: 5,
      // },
    ];

    const newMap = map.reduce((p, o) => {
      const pLast = p[p.length - 1];
      let startDate = campaignStartTime.getTime();

      if (pLast && pLast.endDate) {
        startDate = pLast.endDate;
      }

      p.push({
        ...o,
        startDate: new Date(startDate),
        endDate: new Date(new Date(startDate).getTime() + o.duration * multiplier),
      });

      return p;
    }, []);

    return {
      templates,
      promos: newMap,
    };
  }),
  'transform-your-future-2024': {
    templates: {
      campaign: 'transform-your-future-2024',
      counter: true,
      counterHideDays: false,
      counterDiscountText: 'Current Discount',
      counterHideDiscount: true,
    },
    promos: [
      {
        discount: 72,
        endDate: '2024-01-18T15:00:00Z',
        endDateFinal: '2024-01-18T15:15:00Z',
        btn: 'Start Now',
        coupon: 'TRANSFORM2024',
      },
    ],
  },
  'cyber-monday-2023': {
    templates: {
      campaign: 'cyber-monday-2023',
      counter: true,
      counterHideDays: false,
      counterDiscountText: 'Current Discount',
      counterHideDiscount: true,
    },
    promos: [
      {
        discount: 72,
        endDate: '2023-12-04T15:00:00Z',
        endDateFinal: '2023-12-04T15:00:00Z',
        btn: 'Buy Now',
        coupon: 'CYBERMONDAY2023EXT',
        extend: true,
        className: 'extend',
      },
    ],
  },
  'black-friday-2023': {
    templates: {
      campaign: 'black-friday-2023',
      counter: true,
      counterHideDays: false,
      counterDiscountText: 'Current Discount',
      counterHideDiscount: true,
    },
    promos: [
      {
        discount: 72,
        endDate: '2023-11-27T07:00:00Z',
        btn: 'Buy Now',
        coupon: 'BLACKFRIDAY2023',
      },
    ],
  },
  'free-weeks-2023': {
    templates: {
      campaign: 'free-weeks-2023',
      counter: true,
      isFree: true,
      counterHideDays: false,
      counterDiscountText: 'Current Discount',
      counterHideDiscount: true,
    },
    promos: [
      {
        endDate: '2023-11-20T15:00:00Z',
        btn: 'Start Now',
        coupon: 'asd',
      },
    ],
  },
  // 'get-future-ready': {
  //   templates: {
  //     campaign: 'get-future-ready',
  //     counter: true,
  //     counterHideDays: false,
  //     counterDiscountText: 'Current Discount',
  //     counterHideDiscount: true,
  //     bannerCardTitle: '<span class="line-1">Advance your</span><span class="highlighted">finance career</span> in 2023',
  //     bannerCardDescription: 'Start learning today with an Annual Plan at the best value with our special discounts. Hurry! <b>The price will go up every 48 hours.</b> Now is the best time to take your finance career to the next level with all the benefits of our learning program and a price-lock guarantee.',
  //     promoBannerTitle: { line1: 'Get Top <span>Finance Training</span>', line2: 'WITH <span class="highlighted">SPECIAL DISCOUNTS</span>' },
  //     promoBannerFinalTitle: { line1: 'Last Chance', line2: 'for an <span class="highlighted">EXCLUSIVE DISCOUNT</span>' },
  //   },
  //   promos: [
  //     {
  //       discount: 65,
  //       endDate: '2023-09-28T21:00:00Z',
  //       btn: 'Buy Annual Plan',
  //       coupon: 'FUTUREREADY',
  //     },
  //   ],
  // },
  // 'future-proof': {
  //   templates: {
  //     campaign: 'future-proof',
  //     counter: true,
  //     counterHideDays: false,
  //     counterDiscountText: 'Current Discount',
  //     counterHideDiscount: true,
  //     bannerCardTitle: '<span class="line-1">Advance your</span><span class="highlighted">finance career</span> in 2023',
  //     bannerCardDescription: 'Start learning today with an Annual Plan at the best value with our special discounts. Hurry! <b>The price will go up every 48 hours.</b> Now is the best time to take your finance career to the next level with all the benefits of our learning program and a price-lock guarantee.',
  //     promoBannerTitle: { line1: 'Get Top <span>Finance Training</span>', line2: 'WITH <span class="highlighted">SPECIAL DISCOUNTS</span>' },
  //     promoBannerFinalTitle: { line1: 'Last Chance', line2: 'for an <span class="highlighted">EXCLUSIVE DISCOUNT</span>' },
  //   },
  //   promos: [
  //     {
  //       discount: 65,
  //       endDate: '2023-07-31T14:00:00Z',
  //       btn: 'Buy Annual Plan',
  //       coupon: 'FUTUREPROOF',
  //     },
  //   ],
  // },
  // 'top-finance-training': {
  //   templates: {
  //     campaign: 'top-finance-training',
  //     counter: true,
  //     counterDiscountOnLeft: true,
  //     counterHideDays: true,
  //     counterDiscountText: 'Current Discount',
  //     bannerCardTitle: '<span class="line-1">Advance your</span><span class="highlighted">finance career</span> in 2023',
  //     bannerCardDescription: 'Start learning today with an Annual Plan at the best value with our special discounts. Hurry! <b>The price will go up every 48 hours.</b> Now is the best time to take your finance career to the next level with all the benefits of our learning program and a price-lock guarantee.',
  //     promoBannerTitle: { line1: 'Get Top <span>Finance Training</span>', line2: 'WITH <span class="highlighted">SPECIAL DISCOUNTS</span>' },
  //     promoBannerFinalTitle: { line1: 'Last Chance', line2: 'for an <span class="highlighted">EXCLUSIVE DISCOUNT</span>' },
  //   },
  //   promos: [
  //     {
  //       discount: 68,
  //       endDate: '2023-06-08T14:00:00Z',
  //       btn: 'Save Now',
  //       coupon: 'ADVANCE2023-1',
  //     },
  //     {
  //       discount: 67,
  //       endDate: '2023-06-10T14:00:00Z',
  //       btn: 'Save Now',
  //       coupon: 'ADVANCE2023-2',
  //     },
  //     {
  //       discount: 66,
  //       endDate: '2023-06-12T14:00:00Z',
  //       btn: 'Save Now',
  //       coupon: 'ADVANCE2023-3',
  //     },
  //     {
  //       discount: 65,
  //       endDate: '2023-06-14T14:00:00Z',
  //       btn: 'Save Now',
  //       coupon: 'ADVANCE2023-4',
  //     },
  //     {
  //       discount: 64,
  //       endDate: '2023-06-16T14:00:00Z',
  //       btn: 'Save Now',
  //       coupon: 'ADVANCE2023-5',
  //     },
  //     {
  //       discount: 63,
  //       endDate: '2023-06-18T14:00:00Z',
  //       btn: 'Save Now',
  //       coupon: 'ADVANCE2023-6',
  //     },
  //     {
  //       discount: 62,
  //       endDate: '2023-06-20T14:00:00Z',
  //       coupon: 'ADVANCE2023-7',
  //       btn: 'Grab Now',
  //       className: 'last-promo',
  //       final: true,
  //     },
  //   ],
  // },
  // 'one-of-two-hundred': (() => {
  //   // minutes - 60 * 1000; hours - 60 * 60 * 1000
  //   const multiplier = 60 * 60 * 1000;
  //   // const campaignStartTime = new Date('May 18, 2023 07:50:00');
  //   const campaignStartTime = new Date('2023-05-18T14:00:00Z');
  //   const map = [
  //     {
  //       discount: 72,
  //       duration: 47.5,
  //       coupon: 'ONEOF200-1',
  //       subscriptions: 192,
  //       numbers: [0, 2, 1, 2, 2, 1],
  //       pos: 0,
  //     },
  //     {
  //       discount: 70,
  //       duration: 48,
  //       coupon: 'ONEOF200-2',
  //       subscriptions: 193,
  //       numbers: [0, 2, 1, 2, 2, 1],
  //       pos: 5,
  //     },
  //     {
  //       discount: 68,
  //       duration: 48,
  //       coupon: 'ONEOF200-3',
  //       subscriptions: 193,
  //       numbers: [0, 2, 1, 2, 2, 1],
  //       pos: 5,
  //     },
  //     {
  //       discount: 66,
  //       duration: 48,
  //       coupon: 'ONEOF200-4',
  //       subscriptions: 193,
  //       numbers: [0, 2, 1, 2, 2, 1],
  //       pos: 5,
  //     },
  //     {
  //       discount: 64,
  //       duration: 48,
  //       coupon: 'ONEOF200-5',
  //       subscriptions: 193,
  //       numbers: [0, 2, 1, 2, 2, 1],
  //       pos: 5,
  //     },
  //     {
  //       discount: 62,
  //       duration: 48.5,
  //       coupon: 'ONEOF200-6',
  //       subscriptions: 195,
  //       numbers: [0, 2, 1, 2, 2, 1],
  //       pos: 5,
  //     },
  //   ];

  //   const newMap = map.reduce((p, o) => {
  //     const pLast = p[p.length - 1];
  //     let startDate = campaignStartTime.getTime();

  //     if (pLast && pLast.endDate) {
  //       startDate = pLast.endDate;
  //     }

  //     p.push({
  //       ...o,
  //       startDate: new Date(startDate),
  //       endDate: new Date(new Date(startDate).getTime() + o.duration * multiplier),
  //     });

  //     return p;
  //   }, []);

  //   return {
  //     promos: newMap,
  //     templates: {
  //       campaign: this.$store.state.campaign,
  //       title: `<div class="line-1">GRAB <span class="highlighted">1 of 200</span> <span>SPECIAL-PRICE</span> <span>ANNUAL PLANS</span></div><div class="line-2">Only<span class="subscriptions">${this.subscriptionsLeft}</span>left <span class="new-line">at this price</span></div>`,
  //       description: '<p>Get your annual plan today because the price won\'t be the same tomorrow.</p><p>Start learning at the best cost and get a price-lock guarantee.</p>',
  //     },
  //   };
  // }),
};

export const CAMPAIGN_INSTRUCTORS = {
  ds: [
    {
      name: 'Davis Balaba',
      slug: 'davis-balaba',
    },
    {
      name: 'Danielle Thé',
      slug: 'danielle-the',
    },
    {
      name: 'Anastasia Kuznetsova',
      slug: 'anastasia-kuznetsova',
    },
    {
      name: 'Bernard Marr',
      slug: 'bernard-marr',
    },
    {
      name: 'Shashank Kalanithi',
      slug: 'shashank-kalanithi',
    },
    {
      name: 'Jeff Lee',
      slug: 'jeff-li',
    },
    {
      name: 'Lauren Newbould',
      slug: 'lauren-newbould',
    },
    {
      name: 'Olivier Maugain',
      slug: 'olivier-maugain',
    },
    {
      name: 'Randy Rosseel',
      slug: 'randy-rosseel',
    },
    {
      name: 'Tina Huang',
      slug: 'tina-huang',
    },
    {
      name: 'Ken Jee',
      slug: 'ken-jee',
    },
  ],
  fa: [
    {
      name: 'Ned Krastev',
      slug: 'ned-krastev',
    },
    {
      name: 'Iliya Valchanov',
      slug: 'iliya-valchanov',
    },
    {
      name: 'Ivan Kitov',
      slug: 'ivan-kitov',
    },
    {
      name: 'Gilbert Eijkelenboom',
      slug: 'gilbert-eijkelenboom',
    },
    {
      name: 'Randy Rosseel',
      slug: 'randy-rosseel',
    },
    {
      name: 'Antoniya Baltova',
      slug: 'antoniya-baltova',
    },
    {
      name: 'Peter Lipovyanov',
      slug: 'peter-lipovyanov',
    },
    {
      name: 'Valentina Bogdanova',
      slug: 'valentina-bogdanova',
    },
    {
      name: 'Ivan Vaptsarov',
      slug: 'ivan-vaptsarov',
    },
    {
      name: 'Martin Ganchev',
      slug: 'martin-ganchev',
    },
  ],
};

export const CAMPAIGNS_WITH_SIDE_BANNERS = [
  'most-wanted-2024',
  'future-proof-2024',
  'fast-track-2024',
  'learn-data-and-ai',
  'learn-finance',
  'black-friday-2024',
  'cyber-monday-2024',
  'cyber-monday-lifetime-2024',
  'jumpstart-2025',
];
